export const TEXTS = {
  POINT_DISABLED: 'Ваш адрес вещания отключен',
};
